import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HkbkfacilitiesListComponent } from './hkbkfacilities-list/hkbkfacilities-list.component';
import { HkbkfacilitiesCreateComponent } from './hkbkfacilities-create/hkbkfacilities-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: HkbkfacilitiesListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: HkbkfacilitiesCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'hkbkfacilities-create/:id',
        component: HkbkfacilitiesCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HkbkfacilitiesRoutingModule { }
